import { Injectable } from "@angular/core";

import { ApiService } from "./api.service";
import { LogService } from "./log.service";
import { ApiResponse, ApplicationFeedback } from "../shared/interfaces/api-response";
import { UserRecord } from "../shared/interfaces/user-record";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  constructor(
    private apiService: ApiService,
    private logger: LogService
  ) {}

  async registerUser(username: string, password: string, email: string) {
    const userData = {username: username, password: password, email: email};
    const response: ApiResponse = await this.apiService.post<string|{success: boolean}>("/api/account/register", userData);

    // it is possible response.success is true AND errorMessage is set, in
    // case of server providing feedback like 'username already exists' etc
    let success: boolean;
    let message: string;
    let logMsg: string;
    if (response.success) {
      if(response.body.success) {
        success = true
        message = "Registration successful!"
      } else {
        success = false
        message = response.body
      }

      if (success) {
        logMsg = 'user ' + username + ':' + email + ' registered';
      }
      else {
        logMsg = 'user registration failed for ' + email + ': ' + message;
      }
    }
    else {
      success = false;
      // user-facing message does not need to include response.errorMessage
      //message = response.errorMessage || "Registration failed!  Please try again.";
      message = "Registration failed!  Please try again.";
      logMsg = 'user registration failed for ' + email + ': ' + response.errorMessage;
    }
    await this.logger.info(logMsg);
    return new ApplicationFeedback({success: success, message: message});
  }

  async deleteUser(id: number) {
    const response: ApiResponse = await this.apiService.post<string | {success: boolean}>('api/account/user/delete/' + id, null);

    let success: boolean;
    let message: string;
    let logMsg: string;
    if (response.success) {
      success = !response.errorMessage.trim();

      if (success) {
        message = 'User delete successful!';
        logMsg = 'user ' + id + ' deleted';  // TODO? By $loggedInUser
      }
      else {
        message = 'Failed to delete user';
        logMsg = message + ' ' + id + ': ' + response.errorMessage;
      }
    }
    else {
      success = false;
      message = 'User delete failed!';
      logMsg = message + ' ' + id + ': ' + response.errorMessage;
    }
    await this.logger.info(logMsg);
    return new ApplicationFeedback({success: success, message: message});
  }

  async getAllUsers() {
    const response: ApiResponse = await this.apiService.get<UserRecord[]>("api/account/users");
    if (response.success) {
      return response.body;
    }
    // ApiService will have logged any errors; caller is expecting list
    return [];
  }
}
